import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { TranslationProvider } from '@context/translation-context';
import Loader from '@components/loader';

const ShsAnnoucementBanner = lazy(
  () =>
    import(
      /* webpackChunkName: "shs-announcement-banner" */ './shs-announcement-banner'
    )
);

/**
 * Setup Announcement Banner.
 */
export const annoucmentBanner = () => {
  const annoucmentBanner = document.querySelector('.shs-announcement-banner');
  if (annoucmentBanner) {
    const root = createRoot(annoucmentBanner);
    root.render(
      <Suspense fallback={<Loader />}>
        <TranslationProvider>
          <ShsAnnoucementBanner />
        </TranslationProvider>
      </Suspense>
    );
  }
};
